import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {authHeader} from '../../utils/headers';

const API_BASE = import.meta.env.VITE_APIURL || '';

export const actesApi = createApi({
    reducerPath: 'actesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_BASE,
        prepareHeaders: (headers) => {
            const token = authHeader();
            if (typeof token === 'string' && token) {
                headers.set('authorization', token);
            }
            headers.set('Accept', 'application/ld+json');
            return headers;
        },
    }),
    tagTypes: ['Acte'],
    endpoints: (builder) => ({
        getActes: builder.query({
            query: () => '/actes',
            transformResponse: (r) => r?.['hydra:member'] ?? (Array.isArray(r) ? r : []),
            providesTags: (result) =>
                result
                    ? [...result.map((a) => ({type: 'Acte', id: a.id})), {type: 'Acte', id: 'LIST'}]
                    : [{type: 'Acte', id: 'LIST'}],
        }),
        getActe: builder.query({
            query: (id) => `/actes/${id}`,
            providesTags: (result, error, id) => [{type: 'Acte', id}],
        }),
        createActe: builder.mutation({
            query: (body) => ({
                url: '/actes',
                method: 'POST',
                headers: {'Content-Type': 'application/ld+json'},
                body: JSON.stringify(body),
            }),
            invalidatesTags: [{type: 'Acte', id: 'LIST'}],
        }),
        updateActe: builder.mutation({
            query: ({id, ...patch}) => ({
                url: `/actes/${id}`,
                method: 'PATCH',
                headers: {'Content-Type': 'application/merge-patch+json'},
                body: JSON.stringify(patch),
            }),
            invalidatesTags: (result, error, {id}) => [{type: 'Acte', id}, {type: 'Acte', id: 'LIST'}],
        }),
        deleteActe: builder.mutation({
            query: (id) => ({url: `/actes/${id}`, method: 'DELETE'}),
            invalidatesTags: [{type: 'Acte', id: 'LIST'}],
        }),

        // Éléments de maintenance (zones d'une checklist) — ressources autonomes.
        createElement: builder.mutation({
            query: ({acteId, ...body}) => ({
                url: '/element_maintenances',
                method: 'POST',
                headers: {'Content-Type': 'application/ld+json'},
                body: JSON.stringify(body),
            }),
            invalidatesTags: (result, error, {acteId}) => [{type: 'Acte', id: acteId}],
        }),
        deleteElement: builder.mutation({
            query: ({id}) => ({url: `/element_maintenances/${id}`, method: 'DELETE'}),
            invalidatesTags: (result, error, {acteId}) => [{type: 'Acte', id: acteId}],
        }),
    }),
});

export const {
    useGetActesQuery,
    useGetActeQuery,
    useCreateActeMutation,
    useUpdateActeMutation,
    useDeleteActeMutation,
    useCreateElementMutation,
    useDeleteElementMutation,
} = actesApi;
